class TimetableBlock {
    constructor(el) {
        this.scope = el;
        this.update = el.querySelector('[data-update-results]');
        this.dateSelect = el.querySelector('[data-date-selected]');
        this.activitySelect = el.querySelector('[data-activity-selected]');
        this.pageId = el.dataset.pageId;
        this.bindEvents()
    }

    bindEvents() {
        if (this.update) {
            this.update.addEventListener("click", () => {
                this.handleUpdateResults(this.update.dataset.locationId, this.dateSelect.value, this.activitySelect.value, this.pageId);
            })
        }
    }

    handleUpdateResults(location, date, activityType, pageId) {
        const resultsWrapper = this.scope.querySelector('[data-results]');
        const uri = '/umbraco/surface/Timetable/FilterActivities';

        const data = {
            location: location,
            date: date,
            activityType: activityType !== 'All' ? activityType : undefined,
            pageId: pageId,
        };

        const antiForgeryToken = document.querySelector('input[name="__RequestVerificationToken"]').value;

        fetch(uri, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'RequestVerificationToken': antiForgeryToken
            },
            body: JSON.stringify(data) 
        })
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper) {
                    resultsWrapper.innerHTML = data;
                    this.updateActivitySelectOptions();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    updateActivitySelectOptions() {
        const activityWrapper = this.scope.querySelector('[data-activity-types]');
        const activityData = activityWrapper.dataset.activityTypes;
        const activityTypes = activityData ? activityData.split(',') : false;
        if (activityTypes)
        {
            const selectedValue = this.activitySelect.value
            this.activitySelect.options.length = 1;
            for (let i = 0; i < activityTypes.length; i++){
                const item = activityTypes[i].split('|');
                const el = document.createElement("option");
                el.innerText = item[1];
                el.value = item[0];
                el.selected = selectedValue === item[0]; 
                this.activitySelect.append(el);
            }
        }
        activityWrapper.querySelectorAll("[data-modal]").forEach(el => BindModal(el));
    }
}

ControlBinders.register(`.timetable-block`, el => new TimetableBlock(el));